var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M20.002 15.0638H1.27849C0.427432 15.0638 0.00195312 14.6382 0.00195312 13.7872C0.00195312 12.9361 0.427432 12.5106 1.27849 12.5106H20.002C22.1296 12.5106 23.8316 10.8085 23.8316 8.6808C23.8316 7.40421 22.5551 6.55315 21.2785 6.55315H20.8531C19.5765 6.55315 18.7254 7.40421 18.7254 8.6808C18.7254 9.53186 17.8741 9.95741 17.4486 9.95741C16.5976 9.95741 16.1721 9.53186 16.1721 8.6808C16.1721 6.12762 18.2999 4 20.8531 4H21.2785C24.2572 4 26.3849 6.12762 26.3849 8.6808C26.3849 12.085 23.4062 15.0638 20.002 15.0638Z",
    fill: "url(#paint0_linear_312_3487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M21.2785 36.7638H20.8531C18.2999 36.7638 16.1721 34.6361 16.1721 32.0829C16.1721 31.2319 16.5976 30.8063 17.4486 30.8063C18.2997 30.8063 18.7254 31.2319 18.7254 32.0829C18.7254 33.3595 19.5765 34.6361 20.8531 34.6361H21.2785C22.5551 34.6361 23.8316 33.3595 23.8316 32.0829C23.8316 29.9553 22.1296 28.2532 20.002 28.2532H1.27849C0.427432 28.2532 0.00195312 27.8276 0.00195312 26.9766C0.00195312 26.551 0.427432 25.7 1.27849 25.7H20.002C23.4062 25.7 26.3849 28.6787 26.3849 32.0829C26.3849 34.6361 24.2572 36.7638 21.2785 36.7638Z",
    fill: "url(#paint1_linear_312_3487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M34.0444 21.8724H1.27849C0.427432 21.8724 0.00195312 21.0213 0.00195312 20.5958C0.00195312 19.7447 0.427432 19.3192 1.27849 19.3192H34.0444C35.7465 19.3192 37.4486 17.6171 37.4486 15.4894C37.4486 14.2128 36.5975 12.9362 35.321 12.9362H34.8955C33.6189 12.9362 32.7679 14.2128 32.7679 15.4894C32.7679 15.9149 31.9169 16.766 31.4913 16.766C30.6403 16.766 30.2145 15.9149 30.2145 15.4894C30.2145 12.5107 32.3423 10.3831 34.8955 10.3831H35.321C37.8741 10.3831 40.002 12.5107 40.002 15.4894C40.002 18.8937 37.4487 21.8724 34.0444 21.8724Z",
    fill: "url(#paint2_linear_312_3487)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3487",
    x1: -0.0540107,
    y1: 4.01806,
    x2: 26.3861,
    y2: 4.01806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3487",
    x1: -0.0540107,
    y1: 25.718,
    x2: 26.3861,
    y2: 25.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_3487",
    x1: -0.0828954,
    y1: 10.4018,
    x2: 40.0037,
    y2: 10.4018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindy);
export default __webpack_public_path__ + "static/media/windy.016b5bc9051bf5865b08e7f73ff6072e.svg";
export { ForwardRef as ReactComponent };